var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }